import { Grid, Skeleton } from "@mui/material";
import React from "react";

const TableFiltersSkeleton: React.FC = () => {
  return (
    <Grid container spacing={3}>
      {Array.from(new Array(12)).map((_, index) => (
        <Grid item xs={2} key={index}>
          <Skeleton
            variant="rectangular"
            height={40}
            sx={{ borderRadius: "5px" }}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default TableFiltersSkeleton;
